import { IProductFilter, productFilters } from '@r1-frontend/entities/ConnectDomruPopup/context/constants';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

/**
 * Статусы попапов:
 * connect - открыт попап выбора онлайн-подключения или отправки заявки на обратный звонок;
 * callback - открыт попап отправки заявки на обратный звонок;
 * result - открыт попап результата отправки заявки на обратный звонок;
 * none - все попапы закрыты.
 */
export type TPopupGroupState = 'connect' | 'callback' | 'result' | 'none'

export interface IRequestResult {
    status: EResultPopupStatus,
    message: string,
}

export type TInitialState = {
    view: TPopupGroupState,
    result: IRequestResult,
    productFilters: IProductFilter[],
}

const initialState: TInitialState = {
    view: 'none',
    result: {
        status: EResultPopupStatus.DEFAULT,
        message: '',
    },
    productFilters,
};

export default initialState;
